<template>
    <div class="">

        <!-- barsha -->
        <template
            v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
            <div class="clearfix company-form-container">
                <div class="p-3 employee-investment-wrapper">
                    <div class="">
                        <div class="row no-gutters py-2 mb-3">
                            <div class="col-sm-5 company-form-box-title">Advance Income Tax History</div>
                        </div>
                        <div class="row no-gutters py-2 mb-3">
                            <div class="col-sm-5 company-form-box-title">
                                <div class="custom-search d-none">
                                    <b-input-group class="mb-0">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="search"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input type="search" placeholder="Search.." v-model="search"
                                            @input="resetPagination()"></b-form-input>
                                    </b-input-group>
                                </div>
                            </div>
                            <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                                <button class="btn btn-block btn-secondary tab-button" @click="addNew()">Add Advance Income
                                    Tax</button>
                            </div>
                        </div>
                        <div class="row no-gutters py-2 mb-3" v-if="payrunyears.length > 1"> <!-- Mustafijur: 17-05-2026: Added v-if="payrunyears.length > 1" -->
                            <div class="col-sm-2 company-form-box-title">
                                <select id="year" v-model="year" name="year"
                                    class="form-control custom-select investment-select select_border_color">
                                    <option v-for='pyr in payrunyears' :value='pyr.value'>{{ pyr.text }}</option>
                                </select>
                            </div>
                            <div class="row col-md-10 mb-4 no-margin px-0" v-if="year != null">
                                <div class="investment-total-text-box pt-2">Total Advance Income Tax Recorded For
                                    {{ aits[year].fiscal_year }} : <span style="float:right;">&nbsp;&nbsp; &#2547
                                        {{ aits[year].total }} </span></div>
                            </div>
                            <!-- // Afrin 7-2 -->
                            <!-- added total approved amount for ait -afrin -->
                            <div class="row col-md-12 mb-1 no-margin px-0">
                                <div class="font-weight-bold col-auto center-box m-0 mt-2">Total Approved AIT for
                                    {{
                                        aits[year].fiscal_year }} : <span style="float:right;">&nbsp;&nbsp; &#2547
                                        {{ moneyFormat(aits[year].total_approved) }} </span></div>
                            </div>
                            <!-- end added total approved amount for ait -afrin -->
                            <!-- // Afrin 7-2 -->
                        </div>

                        <div class="employee-table-wrapper table-sticky-height">
                            <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table">
                                <thead>
                                    <tr class="table-head ">
                                        <td> <label class="custom-label"><span>Fiscal Year</span></label> </td>
                                        <td><label class="custom-label "><span>Month</span></label> </td>
                                        <td> <label class="custom-label "><span>Amount</span></label> </td>
                                        <td> <label class="custom-label "><span>Status</span></label> </td>
                                        <!-- <td> <label class="custom-label "><span>Last Activity</span>
                                            <br>
                                            <span class="custom-date-indicator">(YYYY-MM-DD)</span>
                                        </label>
                                        </td> -->
                                        <td>Last Activity <span class="custom-date-indicator d-block ess-date-indicator">(YYYY-MM-DD)</span> </td>
                                        <td> <label class="custom-label "><span>Action</span></label> </td>
                                    </tr>
                                </thead>
                                <template v-if="year != null">
                                    <tbody>
                                        <tr class="hover-bg table-row" v-for="ait_details in aits[year].details"
                                            :key="ait_details.id">

                                            <td class="cursor-pointer trz_relative">
                                                <label class="mb-0 custom-label">{{ ait_details.fiscal_year }}</label>
                                            </td>
                                            <td class="cursor-pointer trz_relative">
                                                <div class=" text-center">
                                                    <template v-for="mnr in months">
                                                        <template
                                                            v-if="mnr.value == ait_details.month">{{ mnr.text }}</template>
                                                    </template>
                                                </div>
                                            </td>
                                            <td class="cursor-pointer trz_relative text-right">
                                                {{ moneyFormat(ait_details.amount) }}
                                            </td>
                                            <td class="cursor-pointer trz_relative">
                                                <div class=""><template v-if="ait_details.status == 1"><b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon></template><template v-else><b-icon icon="dash-circle-fill" variant="warning" class="mr-2"></b-icon></template>{{ statusMap[ait_details.status] }}</div>
                                            </td>
                                            <td class="cursor-pointer trz_relative">
                                                <template v-if="ait_details.updated_at != null">{{
                                                    formatMe(ait_details.updated_at) }}</template>
                                                <template v-else>{{ formatMe(ait_details.created_at) }}</template>
                                            </td>
                                            <td class="cursor-pointer trz_relative">
                                                <div class="col-sm clearfix text-right" v-if="flg > 0">
                                                    <a v-if="ait_details.flg == 1" id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle text-right"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu "
                                                        aria-labelledby="actionDropdown" v-if="ait_details.flg == 1">
                                                        <b-button-toolbar class="">
                                                            <b-button-group class="mr-1">
                                                                <!-- Approver workflow enabled: approve/unapprove flow -->
                                                                <template v-if="aits[year].approver_enabled == 1">
                                                                    <b-button class="text-left" title="Unapprove AIT" @click="approveAit(ait_details.id, 0)"
                                                                        v-if="ait_details.status == 1">
                                                                        <b-icon icon="x-circle"></b-icon> Unapprove
                                                                    </b-button>
                                                                    <template v-if="ait_details.status == 0">
                                                                        <b-button class="text-left" title="Approve AIT" @click="approveAit(ait_details.id, 1)">
                                                                            <b-icon icon="check2-circle"></b-icon> Approve
                                                                        </b-button>
                                                                        <b-button class="text-left" title="Edit AIT" @click="editAit(ait_details.id)">
                                                                            <i class="fa fa-pencil-alt"></i> Edit
                                                                        </b-button>
                                                                        <b-button class="text-left" title="Delete AIT" @click="deleteAit(ait_details.id)">
                                                                            <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                                        </b-button>
                                                                    </template>
                                                                </template>

                                                                <!-- Approver workflow disabled: plain edit/delete -->
                                                                <template v-else>
                                                                    <b-button class="text-left" title="Edit AIT" @click="editAit(ait_details.id)">
                                                                        <i class="fa fa-pencil-alt"></i> Edit
                                                                    </b-button>
                                                                    <b-button class="text-left" title="Delete AIT" @click="deleteAit(ait_details.id)">
                                                                        <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                                    </b-button>
                                                                </template>
                                                            </b-button-group>
                                                        </b-button-toolbar>
                                                    </div>

                                                    <div class="text-center" v-else
                                                        title="This investment can't be edited or deleted since a payrun has been approved after this was listed."
                                                        v-b-tooltip placement="right">
                                                        <b-icon icon="info-circle"></b-icon>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                                <template v-else>
                                    <tr class="hover-bg table-row">
                                        <td class="cursor-pointer trz_relative text-center" colspan="7">No Advance Income
                                            Tax found</td>
                                    </tr>
                                </template>

                            </table>
                        </div>




                    </div>
                </div>
            </div>

        </template>
        <template v-else>
            <lock-template :pageurl="$api_url"></lock-template>
        </template>

        <b-modal id="bv-modal-example" size="lg" hide-footer :title="fdata.id ? 'Edit Advance Income Tax' : 'Add Advance Income Tax'"> <!--Afrin: changed 7-9-->
            <b-form @submit.stop.prevent="onSubmit">
                <div class="clearfix">

                    <div class="col-md-12">

                        <input type="hidden" v-model="fdata.id" name="id">
                        <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field"
                            label-for="fiscal_year">
                            <!--<b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>-->
                            <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year"
                                :options="fiscal_years"></b-form-select>
                        </b-form-group>


                        <b-form-group id="month-group" label="Month" label-for="month">
                            <b-form-select id="month" name="month" v-model="fdata.month" :options="months"></b-form-select>
                        </b-form-group>

                        <b-form-group id="amount-group" label="Advance Income Tax ( ৳ )" class="required-field"
                            label-for="amount">
                            <b-form-input id="amount" name="amount" v-model="fdata.amount"
                                v-validate="{ required: true, min: 3 }" :state="validateState('amount')"
                                aria-describedby="amount-feedback" data-vv-as="Amount"></b-form-input>
                            <b-form-invalid-feedback id="amount-feedback">{{ veeErrors.first('amount')
                            }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>

                <div class="mt-4 ml-4 mb-4 clearfix text-center" style="margin-right: 18px;">
                    <b-button class="border rounded bg-light  py-1 px-5 mt-4 ml-2 btn-primary custom-wizard-btn"
                        variant="primary" @click="resetForm()">Reset</b-button>
                    <b-button class="border rounded bg-light  py-1 px-5 mt-4 ml-2" type="submit"
                        variant="primary">Submit</b-button>
                </div>

            </b-form>
        </b-modal>
        <!-- barsha -->
    </div>
</template>
<script>
    import moment from 'moment';

    export default{

        mounted() {

            //console.log(this.employee_id);
        },
        props: ['flg'],
        data(){

            return {
                itabIndex : 0,
                fiscal_year : this.getCurrentFinancialYear(),
                months: [{ value: 0, text: "N/A" },{ value: 1, text: "January" },{ value: 2, text: "February"},{ value: 3, text: "March"},{ value: 4, text: "April"},{ value: 5, text: "May"},{ value: 6, text: "June"},{ value: 7, text: "July"},{ value: 8, text: "August"},{ value: 9, text: "September"},{ value: 10, text: "October"},{ value: 11, text: "November"},{ value: 12, text: "December", } ],

                aits : [],
                year_aits : [],
                show_year_aits : false,
                showoverlay_list : false,
                successmsg:null,
                errormsg:[],
                fdata: {fiscal_year: this.getCurrentFinancialYear() , month:1, amount:null, id:null },


                fiscal_years: this.$fiscal_year_options,

                decimal_setting: '',


                year: null,
                payrunyears: [
                    { value: null, text: "Select Fiscal Year" },
                ],
                search: '',
                totalaccounts: 0,
                statusMap: {
                    0: 'Pending',
                    1: 'Approved'
                }

            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('YYYY-MM-DD hh:mm:ss A');
            },
            moneyFormat(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                    money = amount;
                else
                    if(this.decimal_setting == 'yes' || this.decimal_setting == ''){
                        if(money.indexOf(".")<0)
                            money = money+'.00';
                    }else{
                        money = money;
                    }
                return money;
            },
            removeDecimal(amount)
            {
                amount = amount.split('.')[0];
                amount = amount.replace('.', '');
                return amount;
            },
            getAits: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.year_aits = [];
                this.show_year_aits = false;
                axios.get(this.$api_url+'/ait/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.aits = response.data;
                    this.tabIndex = 1;
                    // barsha
                    this.totalaccounts = this.aits.length;
                    this.payrunyears = [];
                    this.payrunyears.push({ value: null, text: 'Select Fiscal Year' });
                    Object.values(this.aits).forEach(val => this.payrunyears.push({ value: val.fiscal_year, text: val.fiscal_year }));

                     // Abdullah 13-05-26 added this
                    const years = Object.values(this.aits).map(val => val.fiscal_year);
                    if (years.length > 0) {
                        // this.year = years[years.length - 1];
                        this.year = years.slice().sort().pop();  //Approval update
                    }
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            showAit:function(x)
            {
                this.fiscal_year = x;
                this.year_aits = this.aits[x].details;
                this.show_year_aits = true;
            },
            editAit:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/ait/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.successmsg = null;
                    this.itabIndex = 0;

                    this.$bvModal.show('bv-modal-example');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },

            // Afrin: changed 7-9 start
            approveAit: function (x, y) {
                if (!this.checkNet()) return false;
                var message = y == 1 ? 'Please confirm that you want to Approve this AIT' : 'Please confirm that you want to Unapprove this AIT';
                this.$bvModal.msgBoxConfirm(message, {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
                })
                .then(value => {
                    if (value) {
                        let currentObj = this;

                        let formData = new FormData();
                        formData.append('id', x);
                        formData.append('status', y);

                        axios.post(this.$api_url + '/ait/approve', formData).then(function (response) {
                            if (response.data.status == true) {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.getAits();
                            }
                        }.bind(this)).catch(function (error) { currentObj.serverError(error); });
                    }
                });
            },
            // Afrin: changed 7-9 end

            deleteAit:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm if you want to delete this entry.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/ait/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getAits();
                            }
                            this.showoverlay_list = false;

                        }.bind(this)).catch(function (error){ currentObj.showoverlay_list = false; currentObj.serverError(error);});
                    }
                })
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {fiscal_year:this.getCurrentFinancialYear(), amount:null, id:null};

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-example');
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/ait/save', formData, config)
                        .then(function (response)
                        {
                            this.resetForm();
                            this.getAits();
                            this.itabIndex = 1;

                            this.$bvToast.toast("Saved", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                            //currentObj.errormsg = error.response.data.errors;
                        });

                        this.$bvModal.hide('bv-modal-example');
                });
            },

            get_decimal_settings: function()
            {
              axios.get(this.$api_url+'/decimal-settings')

              .then(function (response) {
                this.decimal_setting = response.data;
              }.bind(this));
            },

        },
        created: function(){
            this.getAits();
            this.get_decimal_settings();
        }
    }
</script>
